import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountData } from '../../user/store/types';
import { userApi } from '../../user/store/userApi';
import { initialLoginError } from '../utils/const';
import { handleLoginErrors } from '../utils/error-handler';
import { deleteToken, setToken } from '../utils/token';

import { authApi } from './authApi';
import type { AuthState } from './types';

export const initialAuthState: AuthState = {
  isAuthenticated: false,
  loginError: initialLoginError,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      deleteToken();
    },
  },
  extraReducers: (builder) => {
    builder

      /* Login */
      .addMatcher(authApi.endpoints.login.matchPending, (state: AuthState) => {
        state.loginError = initialLoginError;
      })
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state: AuthState, action) => {
        const token = action.payload.access_token;
        setToken(token);
      })
      .addMatcher(authApi.endpoints.login.matchRejected, (state: AuthState, action) => {
        if (!action.payload) {
          return;
        }
        const data = action.payload.data;
        const status = action.payload.status as number;
        // state.loginError = handleLoginErrors(status, data);
        state.loginError = handleLoginErrors(status, data);
      })
      /*  Authentication test */
      .addMatcher(userApi.endpoints.account.matchFulfilled, (state: AuthState, action: PayloadAction<AccountData>) => {
        const { role } = action.payload;
        if (role === 'admin' || role === 'organization' || role === 'coach') {
          state.isAuthenticated = true;
        } else {
          state.loginError.common = 'Недостаточно прав';
          deleteToken();
        }
      })
      .addMatcher(userApi.endpoints.account.matchRejected, (state: AuthState, action) => {
        if (action.payload && action.payload.status === 401) {
          deleteToken();
        }
      });
  },
});

export const {
  logout,
} = authSlice.actions;
export { authSlice };

export const selectLoginError = (state: RootState) => state.auth.loginError;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
